/**
 * Masks an email address for privacy display
 * Example: "john@gmail.com" -> "j**n@gmail.com"
 */
export function maskEmail(email: string): string {
    const atIndex = email.indexOf('@');
    if (atIndex === -1) return email;

    const username = email.slice(0, atIndex);
    const domain = email.slice(atIndex);

    if (username.length > 2) {
        const masked = username[0] + '*'.repeat(username.length - 2) + username[username.length - 1];
        return masked + domain;
    }

    return email;
}
